import { render } from "./MainTableComponent.vue?vue&type=template&id=04d1e048&scoped=true"
import script from "./MainTableComponent.vue?vue&type=script&lang=js"
export * from "./MainTableComponent.vue?vue&type=script&lang=js"

import "./MainTableComponent.vue?vue&type=style&index=0&id=04d1e048&scoped=true&lang=css"
import "./MainTableComponent.vue?vue&type=style&index=1&id=04d1e048&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04d1e048"]])

export default __exports__